module.exports = __webpack_public_path__ + "img/security4.a39f3faa.png";